export default "__VITE_ASSET__6d45f4b9__"